import * as ACTION_TYPES from "../types";

let initialState = {
  transactionList: [],
  transaction: {},
  loading: false,
  error: false,
  message: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_TRANSACTİON:
      return { ...state, transactionList: action.data };
    case ACTION_TYPES.ERROR:
      return {
        ...state,
        error: action.data.error,
        message: action.data.message,
      };
    case ACTION_TYPES.RESET_COMMİSSİON:
      return { ...state, error: false };
    case ACTION_TYPES.RESET_TRANSACTION:
      return initialState;
    default:
      return state;
  }
};
